import { BRAND } from "../../data/site";
import { Button } from "../ui/button";
import { Camera, Instagram, Ruler, Send } from "lucide-react";

const DM_URL = BRAND.dmUrl;

const STEPS = [
    {
        icon: Camera,
        title: "Manda una foto",
        text: "Fotografa o salva l'articolo che vuoi: sneakers, abbigliamento o accessori di qualsiasi brand.",
    },
    {
        icon: Ruler,
        title: "Indica la taglia",
        text: "Scrivici la tua taglia nel messaggio: reperiamo qualsiasi brand e taglia.",
    },
    {
        icon: Send,
        title: "Ricevi la risposta in DM",
        text: "Ti rispondiamo direttamente nei DM con disponibilità, prezzo e tempi di consegna.",
    },
];

export const ContactSection = () => {
    return (
        <section id="contatti" data-testid="contact-section" className="py-24 sm:py-32 bg-[#0A0A0A]">
            <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                <div>
                    <p className="text-[#E60000] font-bold uppercase tracking-[0.3em] text-sm mb-4">Contatti</p>
                    <h2 data-testid="contact-title" className="text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white">
                        Scrivici in DM.
                    </h2>
                    <p className="mt-6 text-neutral-300 leading-relaxed max-w-md">
                        Ogni richiesta arriva direttamente nei nostri DM Instagram: nessun modulo,
                        nessuna attesa. Come funziona:
                    </p>
                    <div className="mt-10 space-y-6">
                        {STEPS.map((s, i) => (
                            <div key={s.title} data-testid={`contact-step-${i + 1}`} className="flex gap-4">
                                <div className="shrink-0 h-11 w-11 flex items-center justify-center border border-[#262626] bg-[#141414]">
                                    <s.icon className="h-5 w-5 text-[#E60000]" />
                                </div>
                                <div>
                                    <h3 className="text-white font-semibold uppercase tracking-tight">{s.title}</h3>
                                    <p className="text-sm text-neutral-400 mt-1 leading-relaxed">{s.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div
                    data-testid="contact-dm-card"
                    className="border border-[#262626] bg-[#141414] p-10 text-center hover:border-[#E60000] transition-colors"
                >
                    <img src={BRAND.logo} alt={BRAND.name} className="h-20 w-20 object-cover rounded-sm mx-auto" />
                    <p className="mt-6 text-white font-display font-semibold uppercase tracking-tight text-2xl">
                        Chat diretta con <span className="text-[#E60000]">{BRAND.instagramHandle}</span>
                    </p>
                    <p className="mt-3 text-sm text-neutral-400 leading-relaxed max-w-sm mx-auto">
                        Un tap e sei nella chat: le tue richieste arrivano direttamente nei nostri DM.
                        Risposta rapida, consigli diretti, zero spam.
                    </p>
                    <Button
                        asChild
                        size="lg"
                        className="mt-8 w-full rounded-sm bg-[#E60000] hover:bg-[#c40000] text-white font-bold uppercase tracking-widest hover:-translate-y-1 hover:shadow-[0_4px_20px_rgba(230,0,0,0.4)] transition-all"
                    >
                        <a href={DM_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-open-dm-btn">
                            <Instagram className="mr-2 h-5 w-5" /> Apri la chat Instagram
                        </a>
                    </Button>
                </div>
            </div>
        </section>
    );
};
